import { createApp, h } from 'vue';
import { InertiaProgress } from '@inertiajs/progress';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import VueNumberFormat from 'vue-number-format';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import Toaster from '@meforma/vue-toaster';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.MIX_PUSHER_APP_KEY,
    cluster: process.env.MIX_PUSHER_APP_CLUSTER,
    forceTLS: true
});

try {
    window.$ = window.jQuery = require('jquery');
} catch (e) {}

InertiaProgress.init({
    // delay: 250,
    color: '#29d',
    // includeCSS: true,
    showSpinner: true,
});

const requireComponent = require.context(
    './Components/Form',
    false,
    /[A-Z]\w+\.(vue|js)$/
);



const app = createInertiaApp({
    resolve: name => require(`./${name}`),
    title: title => title ? `${title}` : process.env.APP_NAME,
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(VueTelInput, {
                nationalMode: true,
                utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.17/js/utils.min.js',
                initialCountry: 'my',
                onlyCountries: ['my', 'sg', 'bn', 'id'],
                preferredCountries: ['my'],
                defaultCountry: 'my',
                separateDialCode: true,
                mode: 'national',
            })
            .use(VueNumberFormat, {
                prefix: 'RM',
                suffix: '',
                decimal: '.',
                thousand: ',',
                precision: 2,
                acceptNegative: true,
                isInteger: false
            });
            // .mixin({
            //     methods: {
            //         // $t(str) {
            //         //     return Lang.get(str)
            //         // },
            //         // setLang(lang) {
            //         //     Lang.setLocale(lang)
            //         // },
            //         // capitalize(word) {
            //         //     const lower = word.toLowerCase();
            //         //     return word.charAt(0).toUpperCase() + lower.slice(1);
            //         // }
            //     }
            // });

        app.config.globalProperties.$route = route();

        app.use(Toaster).provide('toastr', app.config.globalProperties.$toast);

        requireComponent.keys().forEach(fileName => {
            const componentConfig = requireComponent(fileName)

            const componentName = upperFirst(
                camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
            )

            app.component(componentName, componentConfig.default || componentConfig)
        })

        app.mount(el);
    },
});

